import { render, staticRenderFns } from "./alertb.vue?vue&type=template&id=661fb239&scoped=true"
import script from "./alertb.vue?vue&type=script&lang=js"
export * from "./alertb.vue?vue&type=script&lang=js"
import style0 from "./alertb.vue?vue&type=style&index=0&id=661fb239&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661fb239",
  null
  
)

export default component.exports